
import React, { useState, useEffect, useRef } from 'react'

import {
    Button,
    Card, Collapse, Grid, Paper, Typography, Select,
    FormHelperText, Dialog, Icon
} from "@material-ui/core";

import useStyles from "./styles";

import { InputBaseField, SelectField } from "../../../components/InputField/InputField";
import { CustomBtn, Label, DraggableComponent } from "../../../components/UiElements/UiElements";
import { GetUserInfo } from "../../../Services/GetUserInfo";
import { PostDataAPI } from '../../../Services/APIService';
import Loader from './../../../components/Loader/Loader';
import { withSnackbar } from "./../../../components/Message/Alert";
import { validatePhoneNumber, handleNumberKeyPress, allowedAttachmentsImages, validateEmail, validateDateOfBirth, formatDate, getFormatedDate } from '../../../components/Common/Extensions';
import { lstStates, lstCountry, lstMonths, documentType, sheilaProgramPlans } from '../../../../src/components/Common/Lookup';
import CloseIcon from '@material-ui/icons/Close';
import { Scrollbars } from 'rc-scrollbars';
import CropDemo from '../../palmBeachTabletsProgram/components/cropImg/CropExample';
function AddNewUser({ dialogOpenClose, handleClose, handleSuccessClose, data, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const inputFile = useRef(null);
    const commonAttachments = allowedAttachmentsImages();
    const [identityImage, setIdentityImage] = useState({ file: null, fileToSend: null, fileName: null });
    const uploadFile = () => {

        inputFile.current.click();
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {

                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }

    const [fileUrl, setFileUrl] = useState(null);
    const [fieldName, setFieldName] = useState(null);

    const [cropImagedialog, setCropImageDialog] = useState(false);

    const handleFileChange = (e) => {
        openCropImage()
        const selectedFile = e.target.files[0];
        const url = URL?.createObjectURL(selectedFile);
        setFileUrl(url);
        setFieldName(e.target)
    }
    const openCropImage = () => {
        setCropImageDialog(true)
    }

    const closeCropImage = () => {
        fieldName.value = ""
        setCropImageDialog(false)
    }

    const ValidateRecord = (errorList) => {
        if (!state.fullName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFullName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFullName: false
            }));
        }

        if (!state.ssn) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSSN: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSSN: false
            }));
        }

        if (!state.dateOfBirth) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: false
            }));
        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: false
            }));
        }

        if (!state.phone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!identityImage.file && !state.identityProof)  {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: false
            }));
        }

        if (!state.agencyName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: false
            }));
        }

        if (!state.agencyLicense) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyLicense: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyLicense: false
            }));
        }

        if (!state.documentType) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: false
            }));
        }


    }

    const onSave = async (croppedImage, fieldName) => {

        const name = fieldName.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        if (fieldName.name === 'identityImage') {
            setIdentityImage({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        } 
        setTimeout(() => {
            setCropImageDialog(false)
        })
    };

    const trimData = () => {
        state.fullName = state.fullName.trim();
        state.email = state.email.trim();
        state.agencyName = state.agencyName.trim()
        state.agencyLicense = state.agencyLicense.trim()
    }

    const addWorker = () => {
        let errorList = [];
        ValidateRecord(errorList);
       
        if (errorList.length < 1) {
            trimData();
            var method = "fdnmcchromicconnect/addSocialWorker";
            if (state.socialWorkerId > 0) {
                method = "fdnmcchromicconnect/updateSocialWorker";
            }
            const formData = new FormData();
            for (var key in state) {
                if (state[key] && key != "fileToSend"
                    && key != "fileName"
                    && key != "identityFile"
                    && key != "identityName"
                    && key != "encUserID"
                )
                    formData.append(key, state[key]);
            }

            formData.append("identityFile", identityImage.fileToSend ? identityImage.fileToSend : '');
            formData.append("identityName", identityImage.fileName ? identityImage.fileName : '');

            setIsLoading(true);
            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        if (state.socialWorkerId && state.socialWorkerId > 0) {
                            handleSuccessClose("Record updated successfully");
                        } else {
                            handleSuccessClose("Record saved successfully");
                        }
                        
                    }
                    else {
                        showMessage("Error", "Error saving social worker information, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
            
        }
    }

    function toDayDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }


    useEffect(() => {

        if (data != null && data.socialWorkerId > 0) {
            data.dateOfBirth = data.dateOfBirth?.split('T')[0]
            setState(data);
        }

    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props} >
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.dialogContent}>
                

            {cropImagedialog ?
                        <CropDemo open={openCropImage} onClose={closeCropImage} fieldName={fieldName} src={fileUrl} onSave={onSave}></CropDemo> : ''
                    }

                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{state.socialWorkerId > 0 ? 'Update Social Worker' : 'Add Social Worker'}</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div>
                            <div className={classes.content}>

                                <Grid container>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Label title="Full Name" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="fullName"
                                                    value={state.fullName}
                                                    onChange={handleChange}
                                                    placeholder="Full Name"
                                                    type="text"
                                                    MaxLength={50}
                                                    useCamelCase={true}
                                                />
                                                {errorMessages.errorFullName && !state.fullName ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter full name
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Last 4 Digit SSN" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="ssn"
                                                    value={state.ssn}
                                                    onChange={handleChange}
                                                    placeholder="Last 4 Digit SSN"
                                                    type="text"
                                                    MaxLength={4}
                                                    onKeyPress={handleNumberKeyPress}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onDrop={(e) => e.preventDefault()}
                                                />
                                                {errorMessages.errorSSN && !state.ssn ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter last 4 digit SSN
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Date of Birth" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="dateOfBirth"
                                                    value={state.dateOfBirth}
                                                    onChange={handleChange}
                                                    placeholder="Date of Birth"
                                                    type="date"
                                                    MaxLength={14}
                                                />
                                                {errorMessages.errorDOB && !state.dateOfBirth ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter date of birth
                                                </FormHelperText>) : ('')}
                                                {errorMessages.errorDOB && state.dateOfBirth > toDayDate() ? (<FormHelperText style={{ color: "red" }} >
                                                    Date of birth cannt be in future
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Email Address" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="email"
                                                    value={state.email}
                                                    onChange={handleChange}
                                                    placeholder="Email Address"
                                                    type="text"
                                                    MaxLength={50}
                                                />
                                                {errorMessages.errorEmail && (!state.email || !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid email address
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Phone #" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="phone"
                                                    value={state.phone}
                                                    onChange={handlePhoneChange}
                                                    placeholder="Phone #"
                                                    type="text"
                                                    MaxLength={14}
                                                />
                                                {errorMessages.errorPhone && (!state.phone || !validatePhoneNumber(state.phone)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid phone #
                                                </FormHelperText>) : ('')}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Agency Name" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="agencyName"
                                                    value={state.agencyName}
                                                    onChange={handleChange}
                                                    placeholder="Agency Name"
                                                    type="text"
                                                    MaxLength={50}
                                                />
                                                {errorMessages.errorAgencyName && !state.agencyName ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter agency name
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="License #" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="agencyLicense"
                                                    value={state.agencyLicense}
                                                    onChange={handleChange}
                                                    placeholder="License #"
                                                    type="text"
                                                    MaxLength={14}
                                                />
                                                {errorMessages.errorAgencyLicense && !state.agencyLicense ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter license #
                                                </FormHelperText>) : ('')}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <Grid row>
                                            <Label title="Document Type" size={12} mandatory={true} />

                                            <Select
                                                size="small"
                                                native
                                                name="documentType"
                                                value={state?.documentType}
                                                onChange={handleSelectChange}
                                                placeholder="Select"
                                                label="Select"
                                                className={classes.selectBaseInput}
                                            >
                                                {documentType.map(option =>
                                                    <option value={option.value}>{option.label}</option>
                                                )
                                                }
                                            </Select>
                                            {errorMessages.errorDocumentType && !state.documentType ? (<FormHelperText style={{ color: "red" }} >
                                                Please select document type
                                            </FormHelperText>) : ('')}
                                        </Grid>


                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <Grid row>
                                            <Label title="Upload Document" size={12} mandatory={true} />
                                            <input
                                                type="file"
                                                id="fileUploadField"
                                                name="identityImage"
                                                ref={inputFile}
                                                className={classes.CustomFileSelection}
                                                onChange={handleFileChange}
                                                accept=".png, .jpg, .jpeg" />
                                            <div className={classes.fileExtenNotif}><i>.png, .jpg, .jpeg files only</i></div>

                                            {errorMessages.errorIdentityImage && (!identityImage.file && !state.identityProof) ? (<FormHelperText style={{ color: "red" }} >
                                                Please select document
                                            </FormHelperText>) : ('')}
                                        </Grid>

                                    </Grid>

                                </Grid>
                                <Grid container className={identityImage.file || state.identityProof ? classes.imageBox : ''}>
                                    {identityImage.file || state.identityProof ?
                                        <>
                                            <img src={identityImage.file ? identityImage.file : '.' + state.identityProof} className={classes.previewImg} style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', width: '325px', height: '204.1px', margin: '5px' }} />
                                        </>
                                        : ''
                                    }
                                </Grid>
                            </div>

                        </div>
                    </Scrollbars>

                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={addWorker}>{state.socialWorkerId > 0 ? 'Update' : 'Add New'}</Button>
                        </div>
                    </div>

                </div>

            </div >
        </Dialog >
    )
}

export default withSnackbar(AddNewUser);

